// extracted by mini-css-extract-plugin
export default {"map":"Map_map__hSXWg","container":"Map_container__TXHTD","loaderContainer":"Map_loaderContainer__2rPTx"};